import { Typography, List, ListItem, ListItemText, Alert, Box, Card, CardContent, Grid, Chip } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function SoporteEnSitioCDMX(){
  return (
    <>
      <SEO 
        title="Soporte en Sitio CDMX | Rolsys Solutions"
        description="Soporte técnico presencial en Ciudad de México. Respuesta rápida y solución de problemas en tu ubicación."
      />

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight:800 }}>
            Soporte en sitio
          </Typography>
          <Chip label="Solo CDMX" color="secondary" />
        </Box>

        <Alert severity="info" sx={{ mb: 4 }}>
          Servicio disponible exclusivamente dentro de Ciudad de México y área metropolitana.
        </Alert>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Servicios incluidos
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Diagnóstico y resolución en sitio"
                      secondary="Identificación y solución de problemas técnicos directamente en tu ubicación"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Instalación y configuración"
                      secondary="Setup completo de equipos, software y sistemas"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Mantenimiento correctivo"
                      secondary="Reparación de fallas y problemas técnicos urgentes"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Capacitación de usuarios"
                      secondary="Entrenamiento presencial para tu equipo de trabajo"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Tiempos de respuesta (SLA)
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Crítico: 2-4 horas" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Alto: 4-8 horas" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Medio: 24 horas" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Bajo: 48-72 horas" />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Cobertura geográfica
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Zona Norte:</strong> Gustavo A. Madero, Azcapotzalco
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Zona Centro:</strong> Cuauhtémoc, Miguel Hidalgo, Benito Juárez
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Zona Sur:</strong> Coyoacán, Álvaro Obregón, Tlalpan
                </Typography>
                <Typography variant="body2">
                  <strong>Área Metropolitana:</strong> Naucalpan, Tlalnepantla, Ecatepec
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}